import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('CrmPageHeader', {
    attrs: {
      "title": _vm.oportunidade ? _vm.oportunidade.titulo : 'Oportunidade',
      "back-label": _vm.backLabel,
      "back-to": _vm.backTo,
      "subtitle": _vm.oportunidadeSubtitle
    }
  }), _vm.loading ? _c('CrmEmptyState', {
    attrs: {
      "title": "Carregando oportunidade...",
      "description": "Buscando dados comerciais, contato e histórico.",
      "icon": "la la-refresh"
    }
  }) : _vm.oportunidade ? _c('div', {
    staticClass: "crm-opportunity"
  }, [_c('section', {
    staticClass: "crm-opportunity-hero"
  }, [_c('div', [_c('span', {
    staticClass: "crm-eyebrow"
  }, [_vm._v("Oportunidade")]), _c('h2', [_vm._v(_vm._s(_vm.oportunidade.titulo))]), _c('div', {
    staticClass: "crm-hero-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.contatoPrincipal))]), _c('span', [_vm._v(_vm._s(_vm.oportunidade.funil.nome || "Funil não informado"))]), _c('span', [_vm._v(_vm._s(_vm.oportunidade.etapa || "Etapa não informada"))])])]), _c('div', {
    staticClass: "crm-hero-actions"
  }, [_c('div', {
    staticClass: "crm-action-group"
  }, [_c('span', {
    staticClass: "crm-status-pill",
    class: _vm.statusClass(_vm.oportunidade.status)
  }, [_vm._v(" " + _vm._s(_vm.statusLabel(_vm.oportunidade.status)) + " ")]), _c('button', {
    staticClass: "crm-action-button is-success",
    attrs: {
      "type": "button",
      "title": "Marcar como ganha"
    },
    on: {
      "click": _vm.abrirModalGanho
    }
  }, [_c('i', {
    staticClass: "la la-check"
  }), _c('span', [_vm._v("Ganhar")])]), _c('button', {
    staticClass: "crm-action-button is-danger",
    attrs: {
      "type": "button",
      "title": "Marcar como perdida"
    },
    on: {
      "click": _vm.abrirModalPerda
    }
  }, [_c('i', {
    staticClass: "la la-times"
  }), _c('span', [_vm._v("Perder")])])]), _c('div', {
    staticClass: "crm-action-group"
  }, [_c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Editar dados"
    },
    on: {
      "click": _vm.abrirModalDados
    }
  }, [_c('i', {
    staticClass: "la la-edit"
  }), _c('span', [_vm._v("Dados")])]), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Criar tarefa"
    },
    on: {
      "click": _vm.abrirModalTarefa
    }
  }, [_c('i', {
    staticClass: "la la-check-square"
  }), _c('span', [_vm._v("Tarefa")])]), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Criar agendamento"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalAgenda();
      }
    }
  }, [_c('i', {
    staticClass: "la la-calendar"
  }), _c('span', [_vm._v("Agenda")])]), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Adicionar nota"
    },
    on: {
      "click": _vm.focusNota
    }
  }, [_c('i', {
    staticClass: "la la-sticky-note"
  }), _c('span', [_vm._v("Nota")])])]), _vm.isContrato ? _c('div', {
    staticClass: "crm-action-group"
  }, [_c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Dados da negociação"
    },
    on: {
      "click": _vm.abrirDadosNegociacao
    }
  }, [_c('i', {
    staticClass: "la la-clipboard"
  }), _c('span', [_vm._v("Negociação")])]), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Enviar contrato por WhatsApp",
      "disabled": !_vm.whatsappUrl
    },
    on: {
      "click": _vm.enviarContratoWhatsapp
    }
  }, [_c('i', {
    staticClass: "la la-whatsapp"
  }), _c('span', [_vm._v("WhatsApp")])]), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Enviar contrato por e-mail",
      "disabled": !_vm.contatoEmail
    },
    on: {
      "click": _vm.enviarContratoEmail
    }
  }, [_c('i', {
    staticClass: "la la-envelope"
  }), _c('span', [_vm._v("E-mail")])])]) : _vm._e()])]), _vm.oportunidade.aguardando_assinatura_contrato ? _c('div', {
    staticClass: "crm-flow-alert"
  }, [_c('i', {
    staticClass: "la la-file-signature"
  }), _c('span', [_vm._v(_vm._s(_vm.oportunidade.aviso_fluxo))])]) : _vm._e(), _vm.etapasFunilAtual.length ? _c('nav', {
    staticClass: "crm-stage-bar"
  }, _vm._l(_vm.etapasFunilAtual, function (etapa, index) {
    return _c('button', {
      key: etapa.id_crm_etapa || etapa.nome,
      staticClass: "crm-stage-item",
      class: {
        active: _vm.etapaAtualIndex === index,
        done: _vm.etapaAtualIndex > index
      },
      attrs: {
        "type": "button",
        "disabled": _vm.stageChanging || _vm.oportunidade.status !== 'aberta' || etapa.id_crm_etapa === _vm.oportunidade.id_crm_etapa
      },
      on: {
        "click": function click($event) {
          return _vm.tentarMoverEtapaDetalhe(etapa);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _c('strong', [_vm._v(_vm._s(etapa.nome))])]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "crm-opportunity-layout"
  }, [_c('aside', {
    staticClass: "crm-opportunity-side"
  }, [_c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Dados principais")]), _c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalDados
    }
  }, [_vm._v(" Editar ")])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Status")]), _c('strong', [_vm._v(_vm._s(_vm.statusLabel(_vm.oportunidade.status)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Funil")]), _c('strong', [_vm._v(_vm._s(_vm.oportunidade.funil.nome || "-"))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Etapa")]), _c('strong', [_vm._v(_vm._s(_vm.oportunidade.etapa || "-"))])]), !_vm.ocultarValoresFinanceirosDetalhe ? [_c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Valor principal")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.valorPrincipalDetalhe)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Estimado")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.oportunidade.valor_estimado)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Proposta")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoneyOrDash(_vm.valorPropostaDetalhe)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Negociação")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoneyOrDash(_vm.valorNegociacaoDetalhe)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Final")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoneyOrDash(_vm.valorFinalDetalhe)))])])] : _vm._e(), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Previsão")]), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.oportunidade.previsao_fechamento)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Próxima ação")]), _c('strong', [_vm._v(_vm._s(_vm.formatDateTime(_vm.oportunidade.proxima_atividade_em)))])]), _c('div', {
    staticClass: "crm-detail-row"
  }, [_c('span', [_vm._v("Temperatura")]), _c('button', {
    staticClass: "crm-temperature-button",
    style: {
      '--temperature-color': _vm.temperaturaColor(_vm.oportunidade.temperatura)
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTemperaturaDetalhe
    }
  }, [_c('i', {
    class: _vm.temperaturaIcon(_vm.oportunidade.temperatura)
  }), _c('strong', [_vm._v(" " + _vm._s(_vm.temperaturaLabel(_vm.oportunidade.temperatura)) + " ")])])])], 2), _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Origem")])]), _c('div', {
    staticClass: "crm-contact-card"
  }, [_c('strong', [_vm._v(_vm._s(_vm.oportunidade.fonte || "Fonte não informada"))]), _c('span', [_vm._v(_vm._s(_vm.oportunidade.campanha || "Campanha não informada"))])])]), _vm.automacoesEtapa.length ? _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Regras da etapa")])]), _c('div', {
    staticClass: "crm-rule-list"
  }, _vm._l(_vm.automacoesEtapa, function (regra) {
    return _c('span', {
      key: regra,
      staticClass: "crm-rule-pill"
    }, [_vm._v(" " + _vm._s(regra) + " ")]);
  }), 0)]) : _vm._e(), _vm.camposComerciaisDetalhe.length ? _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Campos comerciais")]), _c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalDados
    }
  }, [_vm._v(" Editar ")])]), _vm._l(_vm.camposComerciaisDetalhe, function (campo) {
    return _c('div', {
      key: campo.id_crm_campo_comercial,
      staticClass: "crm-detail-row"
    }, [_c('span', [_vm._v(_vm._s(campo.nome))]), _c('strong', [_vm._v(_vm._s(_vm.campoValorLabel(campo)))])]);
  })], 2) : _vm._e(), _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Contato")]), _c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalContato
    }
  }, [_vm._v(" " + _vm._s(_vm.oportunidade.id_crm_contato ? "Trocar" : "Adicionar") + " ")])]), _c('div', {
    staticClass: "crm-contact-card"
  }, [_c('strong', [_vm._v(_vm._s(_vm.oportunidade.contato || "Contato CRM não vinculado"))]), _c('span', [_vm._v(_vm._s(_vm.contatoTelefone || "Telefone não informado"))]), _c('span', [_vm._v(_vm._s(_vm.contatoEmail || "E-mail não informado"))]), _c('div', {
    staticClass: "crm-contact-actions"
  }, [_c('button', {
    staticClass: "btn btn-light btn-xs",
    attrs: {
      "type": "button",
      "disabled": !_vm.contatoTelefone
    },
    on: {
      "click": _vm.copiarTelefoneContato
    }
  }, [_vm._v(" Copiar telefone ")]), _c('button', {
    staticClass: "btn btn-light-success btn-xs",
    attrs: {
      "type": "button",
      "disabled": !_vm.whatsappUrl
    },
    on: {
      "click": _vm.abrirWhatsappContato
    }
  }, [_vm._v(" WhatsApp ")])])])]), _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Empresa")]), _c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalEmpresa
    }
  }, [_vm._v(" " + _vm._s(_vm.oportunidade.id_pessoa ? "Trocar" : "Associar") + " ")])]), _c('div', {
    staticClass: "crm-contact-card"
  }, [_c('strong', [_vm._v(_vm._s(_vm.empresaLabel || "Empresa não vinculada"))]), _c('span', [_vm._v(_vm._s(_vm.empresaDocumento || "Documento não informado"))])])]), _c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('h3', [_vm._v("Responsável")])]), _c('div', {
    staticClass: "crm-contact-card"
  }, [_c('strong', [_vm._v(_vm._s(_vm.oportunidade.usuario || "Sem responsável"))]), _c('span', [_vm._v("Responsável comercial")])]), _c('div', {
    staticClass: "crm-contact-card mt-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.oportunidade.vendedor_responsavel || "-"))]), _c('span', [_vm._v("Vendedor fixo")])]), _c('div', {
    staticClass: "crm-contact-card mt-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.oportunidade.responsavel_tecnico || "-"))]), _c('span', [_vm._v("Responsável técnico")])])])]), _c('main', {
    staticClass: "crm-opportunity-main"
  }, [_c('section', {
    staticClass: "crm-panel"
  }, [_c('div', {
    staticClass: "crm-panel-header"
  }, [_c('div', [_c('h3', [_vm._v("Próximas tarefas")]), _c('span', [_vm._v(_vm._s(_vm.proximasAcoesPendentesCount) + " pendentes em destaque")])]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTarefa
    }
  }, [_vm._v(" Criar tarefa ")])]), _vm.listasLoading ? _c('CrmEmptyState', {
    attrs: {
      "title": "Carregando ações...",
      "description": "Buscando tarefas e agendamentos desta oportunidade.",
      "icon": "la la-refresh"
    }
  }) : _vm.proximasTarefas.length === 0 && _vm.solicitacoesTecnicasPendentes.length === 0 ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhuma tarefa pendente",
      "description": "Crie uma tarefa para manter o próximo passo claro.",
      "icon": "la la-check-circle"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-light-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.abrirModalTarefa
          }
        }, [_vm._v(" Criar tarefa ")])];
      },
      proxy: true
    }])
  }) : _c('div', [_vm.solicitacoesTecnicasPendentes.length ? _c('div', {
    staticClass: "crm-technical-request-list"
  }, _vm._l(_vm.solicitacoesTecnicasPendentes, function (solicitacao) {
    return _c('article', {
      key: solicitacao.id_crm_solicitacao_tecnica,
      staticClass: "crm-technical-request"
    }, [_c('div', {
      staticClass: "crm-technical-request-info"
    }, [_c('strong', [_vm._v("Apresentação técnica")]), _c('span', [_vm._v(" " + _vm._s(_vm.solicitacaoTecnicaStatusLabel(solicitacao.status)) + " · " + _vm._s(solicitacao.tecnico || "Técnico não definido") + " ")]), solicitacao.agenda_data_inicio ? _c('small', [_vm._v(" Agendado em " + _vm._s(_vm.formatDateTime(solicitacao.agenda_data_inicio)) + " ")]) : solicitacao.link_url ? _c('small', [_vm._v(" Link gerado para envio ao cliente ")]) : _c('small', [_vm._v("Solicitação aguardando agenda")])]), _c('div', {
      staticClass: "crm-technical-request-actions"
    }, [_c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Gerar link"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirModalLinkSolicitacaoTecnica(solicitacao);
        }
      }
    }, [_c('i', {
      staticClass: "la la-link"
    }), _c('span', [_vm._v("Gerar")])]), _c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Copiar link",
        "disabled": !_vm.linkPublicoSolicitacao(solicitacao)
      },
      on: {
        "click": function click($event) {
          return _vm.copiarLinkSolicitacaoTecnica(solicitacao);
        }
      }
    }, [_c('i', {
      staticClass: "la la-copy"
    }), _c('span', [_vm._v("Copiar")])]), _c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Enviar por WhatsApp",
        "disabled": !_vm.linkPublicoSolicitacao(solicitacao) || !_vm.contatoTelefone
      },
      on: {
        "click": function click($event) {
          return _vm.enviarLinkTecnicoWhatsapp(solicitacao);
        }
      }
    }, [_c('i', {
      staticClass: "la la-whatsapp"
    }), _c('span', [_vm._v("WhatsApp")])]), _c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Enviar por e-mail",
        "disabled": !_vm.linkPublicoSolicitacao(solicitacao) || !_vm.contatoEmail
      },
      on: {
        "click": function click($event) {
          return _vm.enviarLinkTecnicoEmail(solicitacao);
        }
      }
    }, [_c('i', {
      staticClass: "la la-envelope"
    }), _c('span', [_vm._v("E-mail")])]), _c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Agendar direto"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirAgendaSolicitacaoTecnica(solicitacao);
        }
      }
    }, [_c('i', {
      staticClass: "la la-calendar"
    }), _c('span', [_vm._v("Agendar")])]), _c('button', {
      staticClass: "crm-action-button is-small",
      attrs: {
        "type": "button",
        "title": "Ver horários"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirAgendaSolicitacaoTecnica(solicitacao, true);
        }
      }
    }, [_c('i', {
      staticClass: "la la-clock"
    }), _c('span', [_vm._v("Horários")])])])]);
  }), 0) : _vm._e(), _vm.proximasTarefas.length ? _c('div', {
    staticClass: "crm-task-list"
  }, _vm._l(_vm.proximasTarefas, function (tarefa) {
    return _c('article', {
      key: tarefa.id_crm_atividade,
      staticClass: "crm-task-item",
      class: {
        late: _vm.atividadeAtrasada(tarefa)
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(tarefa.titulo))]), _c('span', [_vm._v(" " + _vm._s(_vm.tipoTarefaLabel(tarefa.tipo)) + " · " + _vm._s(_vm.formatDateTime(tarefa.vencimento_em)) + " ")])]), _c('div', {
      staticClass: "crm-task-actions"
    }, [_vm.isTarefaContrato(tarefa) ? _c('button', {
      staticClass: "btn btn-light-info btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.abrirDadosNegociacao
      }
    }, [_vm._v(" Dados ")]) : _vm._e(), tarefa.status === 'aberta' ? _c('button', {
      staticClass: "btn btn-light btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirEditarTarefa(tarefa);
        }
      }
    }, [_vm._v(" Editar ")]) : _vm._e(), _vm.tarefaTemAgendaAtiva(tarefa) ? _c('button', {
      staticClass: "btn btn-light-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirReagendamentoTarefa(tarefa);
        }
      }
    }, [_vm._v(" Reagendar ")]) : _c('button', {
      staticClass: "btn btn-light-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirModalAgenda(tarefa);
        }
      }
    }, [_vm._v(" Agendar ")]), tarefa.status === 'aberta' ? _c('button', {
      staticClass: "btn btn-light-success btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.concluirTarefa(tarefa);
        }
      }
    }, [_vm._v(" Concluir ")]) : _vm._e()])]);
  }), 0) : _vm._e()])], 1), _c('section', {
    staticClass: "crm-panel crm-tabs-panel"
  }, [_c('b-tabs', {
    attrs: {
      "nav-class": "crm-tabs-nav"
    },
    model: {
      value: _vm.activeTab,
      callback: function callback($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Histórico"
    }
  }, [_c('div', {
    staticClass: "crm-tab-toolbar"
  }, [_c('strong', [_vm._v(_vm._s(_vm.timelineCountLabel))]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.loadTimeline(true);
      }
    }
  }, [_vm._v(" Atualizar ")])]), _c('div', {
    staticClass: "crm-timeline-filters"
  }, [_vm._l(_vm.timelineFiltroOptions, function (filtro) {
    return _c('button', {
      key: filtro.value,
      staticClass: "crm-timeline-filter",
      class: {
        active: _vm.timelineFiltro === filtro.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.alterarFiltroTimeline(filtro.value);
        }
      }
    }, [_c('i', {
      class: filtro.icon
    }), _c('span', [_vm._v(_vm._s(filtro.text))])]);
  }), _c('button', {
    staticClass: "crm-timeline-filter crm-timeline-upload",
    attrs: {
      "type": "button",
      "disabled": _vm.timelineUploading
    },
    on: {
      "click": _vm.abrirUploadAnexoTimeline
    }
  }, [_c('i', {
    staticClass: "la la-paperclip"
  }), _c('span', [_vm._v(" " + _vm._s(_vm.timelineUploading ? "Enviando..." : "Anexar") + " ")])]), _c('input', {
    ref: "timelineAnexoInput",
    staticClass: "d-none",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.salvarAnexoTimeline
    }
  })], 2), _c('div', {
    staticClass: "crm-quick-note"
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Adicionar nota rápida ao histórico",
      "rows": "2"
    },
    model: {
      value: _vm.timelineNotaRapida,
      callback: function callback($$v) {
        _vm.timelineNotaRapida = $$v;
      },
      expression: "timelineNotaRapida"
    }
  }), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarNotaRapida
    }
  }, [_vm._v(" Salvar nota ")])], 1), _vm.timelineLoading ? _c('CrmEmptyState', {
    attrs: {
      "title": "Carregando timeline...",
      "description": "Organizando eventos recentes desta oportunidade.",
      "icon": "la la-refresh"
    }
  }) : _vm.timelineAgrupada.length === 0 ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhum evento encontrado",
      "description": "Crie uma tarefa, agendamento ou nota para registrar o histórico da oportunidade.",
      "icon": "la la-history"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-light-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.abrirModalTarefa
          }
        }, [_vm._v(" Criar tarefa ")])];
      },
      proxy: true
    }])
  }) : _c('div', _vm._l(_vm.timelineAgrupada, function (grupo) {
    return _c('section', {
      key: grupo.key,
      staticClass: "crm-timeline-group"
    }, [_c('div', {
      staticClass: "crm-timeline-group-title"
    }, [_c('span', [_vm._v(_vm._s(grupo.label))]), _c('small', [_vm._v(_vm._s(grupo.items.length) + " eventos")])]), _vm._l(grupo.items, function (item) {
      return _c('CrmTimelineItem', {
        key: item.id_crm_timeline,
        attrs: {
          "title": _vm.timelineTitle(item.tipo_evento),
          "description": item.descricao,
          "date": item.created_at,
          "user": item.usuario || 'CRM',
          "type": _vm.timelineCategoriaLabel(item.tipo_evento),
          "status": _vm.timelineStatus(item.tipo_evento)
        },
        scopedSlots: _vm._u([{
          key: "actions",
          fn: function fn() {
            return [_vm.timelineAnexoUrl(item) ? _c('a', {
              staticClass: "btn btn-light-primary btn-xs mt-2 mr-2",
              attrs: {
                "href": _vm.timelineAnexoUrl(item),
                "target": "_blank",
                "rel": "noopener"
              }
            }, [_c('i', {
              staticClass: "la la-download"
            }), _vm._v(" Baixar " + _vm._s(_vm.timelineAnexoNome(item)) + " ")]) : _vm._e(), _vm.timelineAgendavel(item) ? _c('button', {
              staticClass: "btn btn-light-primary btn-xs mt-2",
              attrs: {
                "type": "button"
              },
              on: {
                "click": function click($event) {
                  return _vm.agendarTarefaTimeline(item);
                }
              }
            }, [_vm._v(" Agendar tarefa ")]) : _vm._e()];
          },
          proxy: true
        }], null, true)
      });
    })], 2);
  }), 0), _vm.timelineHasMore ? _c('div', {
    staticClass: "text-center mt-4"
  }, [_c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.loadTimeline(false);
      }
    }
  }, [_vm._v(" Carregar mais ")])]) : _vm._e()], 1), _c('b-tab', {
    attrs: {
      "title": "Tarefas"
    }
  }, [_c('div', {
    staticClass: "crm-tab-toolbar"
  }, [_c('strong', [_vm._v(_vm._s(_vm.atividades.length) + " tarefas")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalTarefa
    }
  }, [_vm._v(" Criar tarefa ")])]), _vm.atividades.length === 0 ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhuma tarefa criada",
      "description": "Registre ligações, follow-ups e reuniões para acompanhar a negociação.",
      "icon": "la la-list"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-light-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.abrirModalTarefa
          }
        }, [_vm._v(" Criar tarefa ")])];
      },
      proxy: true
    }], null, false, 448226934)
  }) : _c('div', {
    staticClass: "crm-task-list"
  }, _vm._l(_vm.atividades, function (tarefa) {
    return _c('article', {
      key: tarefa.id_crm_atividade,
      staticClass: "crm-task-item",
      class: {
        late: _vm.atividadeAtrasada(tarefa)
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(tarefa.titulo))]), _c('span', [_vm._v(" " + _vm._s(_vm.tipoTarefaLabel(tarefa.tipo)) + " · " + _vm._s(_vm.atividadeStatusLabel(tarefa.status)) + " · " + _vm._s(_vm.formatDateTime(tarefa.vencimento_em)) + " ")]), tarefa.descricao ? _c('p', [_vm._v(_vm._s(tarefa.descricao))]) : _vm._e()]), _c('div', {
      staticClass: "crm-task-actions"
    }, [tarefa.status === 'aberta' ? _c('button', {
      staticClass: "btn btn-light btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirEditarTarefa(tarefa);
        }
      }
    }, [_vm._v(" Editar ")]) : _vm._e(), _vm.tarefaTemAgendaAtiva(tarefa) ? _c('button', {
      staticClass: "btn btn-light-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirReagendamentoTarefa(tarefa);
        }
      }
    }, [_vm._v(" Reagendar ")]) : _c('button', {
      staticClass: "btn btn-light-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirModalAgenda(tarefa);
        }
      }
    }, [_vm._v(" Agendar ")]), tarefa.status === 'aberta' ? _c('button', {
      staticClass: "btn btn-light-success btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.concluirTarefa(tarefa);
        }
      }
    }, [_vm._v(" Concluir ")]) : _vm._e()])]);
  }), 0)], 1), _c('b-tab', {
    attrs: {
      "title": "Agendamentos"
    }
  }, [_c('div', {
    staticClass: "crm-tab-toolbar"
  }, [_c('strong', [_vm._v(_vm._s(_vm.agendas.length) + " agendamentos CRM")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirModalAgenda();
      }
    }
  }, [_vm._v(" Criar agendamento ")])]), _vm.agendas.length === 0 ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhum agendamento CRM",
      "description": "Agende reuniões, visitas e retornos sem depender da agenda operacional.",
      "icon": "la la-calendar"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn() {
        return [_c('button', {
          staticClass: "btn btn-light-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.abrirModalAgenda();
            }
          }
        }, [_vm._v(" Criar agendamento ")])];
      },
      proxy: true
    }], null, false, 285238317)
  }) : _c('div', {
    staticClass: "crm-task-list"
  }, _vm._l(_vm.agendas, function (agenda) {
    return _c('article', {
      key: agenda.id_crm_agenda,
      staticClass: "crm-task-item"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(agenda.titulo))]), _c('span', [_vm._v(" " + _vm._s(_vm.tipoAgendaLabel(agenda.tipo)) + " · " + _vm._s(_vm.agendaStatusLabel(agenda.status)) + " · " + _vm._s(_vm.formatDateTime(agenda.data_inicio)) + " ")]), agenda.descricao ? _c('p', [_vm._v(_vm._s(agenda.descricao))]) : _vm._e()]), _c('div', {
      staticClass: "crm-task-actions"
    }, [_vm.podeReagendarAgenda(agenda) ? _c('button', {
      staticClass: "btn btn-light-primary btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirReagendamentoAgenda(agenda);
        }
      }
    }, [_vm._v(" Reagendar ")]) : _vm._e(), _vm.podeCancelarAgenda(agenda) ? _c('button', {
      staticClass: "btn btn-light-danger btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.cancelarAgenda(agenda);
        }
      }
    }, [_vm._v(" Cancelar ")]) : _vm._e(), _vm.podeConcluirAgenda(agenda) ? _c('button', {
      staticClass: "btn btn-light-success btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.alterarStatusAgenda(agenda, 'concluido');
        }
      }
    }, [_vm._v(" Concluir ")]) : _vm._e()])]);
  }), 0)], 1), _c('b-tab', {
    attrs: {
      "title": "Notas"
    }
  }, [_c('div', {
    staticClass: "crm-note-box"
  }, [_c('b-form-textarea', {
    ref: "notaInput",
    attrs: {
      "placeholder": "Registre uma anotação para a oportunidade",
      "rows": "4"
    },
    model: {
      value: _vm.nota,
      callback: function callback($$v) {
        _vm.nota = $$v;
      },
      expression: "nota"
    }
  }), _c('div', {
    staticClass: "text-right mt-3"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarNota
    }
  }, [_vm._v(" Salvar nota ")])])], 1), _vm.notasTimeline.length === 0 ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhuma nota registrada",
      "description": "Anotações ajudam a manter o histórico claro para todo o time.",
      "icon": "la la-sticky-note"
    }
  }) : _c('div', {
    staticClass: "mt-4"
  }, _vm._l(_vm.notasTimeline, function (item) {
    return _c('CrmTimelineItem', {
      key: item.id_crm_timeline,
      attrs: {
        "title": _vm.timelineTitle(item.tipo_evento),
        "description": item.descricao,
        "date": item.created_at,
        "user": item.usuario || 'CRM',
        "type": item.tipo_evento
      }
    });
  }), 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Contatos"
    }
  }, [_c('div', {
    staticClass: "crm-contact-grid"
  }, [_c('div', {
    staticClass: "crm-contact-card"
  }, [_c('span', [_vm._v("Contato CRM")]), _c('strong', [_vm._v(_vm._s(_vm.oportunidade.contato || "Não vinculado"))]), _c('span', [_vm._v(_vm._s(_vm.contatoTelefone || "Telefone não informado"))]), _c('span', [_vm._v(_vm._s(_vm.contatoEmail || "E-mail não informado"))]), _c('div', {
    staticClass: "crm-contact-actions"
  }, [_c('button', {
    staticClass: "btn btn-light btn-xs",
    attrs: {
      "type": "button",
      "disabled": !_vm.contatoTelefone
    },
    on: {
      "click": _vm.copiarTelefoneContato
    }
  }, [_vm._v(" Copiar ")]), _c('button', {
    staticClass: "btn btn-light-success btn-xs",
    attrs: {
      "type": "button",
      "disabled": !_vm.whatsappUrl
    },
    on: {
      "click": _vm.abrirWhatsappContato
    }
  }, [_vm._v(" WhatsApp ")]), _c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalContato
    }
  }, [_vm._v(" " + _vm._s(_vm.oportunidade.id_crm_contato ? "Trocar" : "Adicionar") + " ")])])]), _c('div', {
    staticClass: "crm-contact-card"
  }, [_c('span', [_vm._v("Pessoa/empresa")]), _c('strong', [_vm._v(_vm._s(_vm.empresaLabel || "Não vinculada"))]), _c('span', [_vm._v(_vm._s(_vm.empresaDocumento || "Documento não informado"))]), _c('div', {
    staticClass: "crm-contact-actions"
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalEmpresa
    }
  }, [_vm._v(" " + _vm._s(_vm.oportunidade.id_pessoa ? "Trocar" : "Associar") + " ")])])])]), !_vm.oportunidade.contato && !_vm.oportunidade.pessoa ? _c('CrmEmptyState', {
    attrs: {
      "title": "Nenhum contato vinculado",
      "description": "Esta oportunidade ainda não tem contato ou cadastro associado.",
      "icon": "la la-user"
    }
  }) : _vm._e()], 1)], 1)], 1)])])]) : _c('CrmEmptyState', {
    attrs: {
      "title": "Não foi possível abrir o card",
      "description": _vm.erroOportunidade || 'Atualize a página ou tente abrir o card pelo funil novamente.',
      "icon": "la la-exclamation-circle"
    }
  }), _c('b-sidebar', {
    attrs: {
      "id": "crm-detalhe-tarefa-drawer",
      "title": _vm.tarefaDrawerTitle,
      "backdrop": "",
      "right": "",
      "shadow": "",
      "width": "520px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "crm-drawer-footer"
        }, [_c('button', {
          staticClass: "btn btn-light mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.tarefaDrawerVisible = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('button', {
          staticClass: "btn btn-light-primary mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.salvarTarefa(true);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.tarefaEditando ? "Salvar e agendar" : "Criar e agendar") + " ")]), _c('button', {
          staticClass: "btn btn-dark",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.salvarTarefa(false);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.tarefaEditando ? "Salvar alterações" : "Salvar tarefa") + " ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.tarefaDrawerVisible,
      callback: function callback($$v) {
        _vm.tarefaDrawerVisible = $$v;
      },
      expression: "tarefaDrawerVisible"
    }
  }, [_c('div', {
    staticClass: "crm-drawer-body"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.tarefaForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "titulo", $$v);
      },
      expression: "tarefaForm.titulo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoTarefaOptions
    },
    model: {
      value: _vm.tarefaForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "tipo", $$v);
      },
      expression: "tarefaForm.tipo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptions
    },
    model: {
      value: _vm.tarefaForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "id_usuario", $$v);
      },
      expression: "tarefaForm.id_usuario"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Vencimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.tarefaForm.vencimento_em,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "vencimento_em", $$v);
      },
      expression: "tarefaForm.vencimento_em"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.tarefaForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "descricao", $$v);
      },
      expression: "tarefaForm.descricao"
    }
  })], 1), !_vm.tarefaEditando ? _c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.tarefaForm.concluir_ao_criar,
      callback: function callback($$v) {
        _vm.$set(_vm.tarefaForm, "concluir_ao_criar", $$v);
      },
      expression: "tarefaForm.concluir_ao_criar"
    }
  }, [_vm._v(" Concluir ao criar ")]) : _vm._e()], 1)]), _c('b-sidebar', {
    attrs: {
      "id": "crm-detalhe-agenda-drawer",
      "title": _vm.agendaDrawerTitle,
      "backdrop": "",
      "right": "",
      "shadow": "",
      "width": "560px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "crm-drawer-footer"
        }, [_c('button', {
          staticClass: "btn btn-light",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              _vm.agendaDrawerVisible = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('button', {
          staticClass: "btn btn-dark",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.criarAgenda
          }
        }, [_vm._v(" Salvar agendamento ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.agendaDrawerVisible,
      callback: function callback($$v) {
        _vm.agendaDrawerVisible = $$v;
      },
      expression: "agendaDrawerVisible"
    }
  }, [_c('div', {
    staticClass: "crm-drawer-body"
  }, [_vm.tarefaAgendamentoOrigem ? _c('div', {
    staticClass: "crm-agenda-cliente mb-4"
  }, [_c('span', [_vm._v("Tarefa vinculada")]), _c('strong', [_vm._v(_vm._s(_vm.tarefaAgendamentoOrigem.titulo))])]) : _vm._e(), _c('div', {
    staticClass: "crm-agenda-cliente mb-4"
  }, [_c('span', [_vm._v("Cliente ou contato")]), _c('strong', [_vm._v(_vm._s(_vm.agendaClienteLabel))])]), _c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.agendaForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "titulo", $$v);
      },
      expression: "agendaForm.titulo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoAgendaOptions
    },
    model: {
      value: _vm.agendaForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "tipo", $$v);
      },
      expression: "agendaForm.tipo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": _vm.agendaResponsavelLabel
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.agendaResponsavelOptions
    },
    model: {
      value: _vm.agendaForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "id_usuario", $$v);
      },
      expression: "agendaForm.id_usuario"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data e horário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.agendaForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "data_inicio", $$v);
      },
      expression: "agendaForm.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração em minutos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.agendaForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "duracao_minutos", $$v);
      },
      expression: "agendaForm.duracao_minutos"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "crm-agenda-horarios"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('div', [_c('strong', [_vm._v("Horários disponíveis")]), _c('small', {
    staticClass: "crm-agenda-context"
  }, [_vm._v(" " + _vm._s(_vm.agendaHorariosContextoLabel) + " ")])]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingAgendaHorarios
    },
    on: {
      "click": _vm.buscarHorariosAgenda
    }
  }, [_vm._v(" Buscar horários ")])]), _vm.agendaHorariosErro ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_vm._v(" " + _vm._s(_vm.agendaHorariosErro) + " ")]) : _vm.loadingAgendaHorarios ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Carregando horários... ")]) : _vm.agendaSlots.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Busque os horários antes de marcar. ")]) : _c('div', {
    staticClass: "crm-agenda-slots"
  }, _vm._l(_vm.agendaSlots, function (slot) {
    return _c('button', {
      key: slot.inicio,
      staticClass: "crm-agenda-slot",
      class: {
        selected: _vm.agendaSlotSelecionado(slot),
        unavailable: !slot.disponivel
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.agendaSlotSelecionado(slot),
        "disabled": !slot.disponivel
      },
      on: {
        "click": function click($event) {
          return _vm.selecionarHorarioAgenda(slot);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatTime(slot.inicio)))]), _c('small', [_vm._v(" " + _vm._s(slot.disponivel ? "Livre" : slot.motivo || "Ocupado") + " ")])]);
  }), 0)]), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.agendaForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaForm, "descricao", $$v);
      },
      expression: "agendaForm.descricao"
    }
  })], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-reagendar-agenda-modal",
      "title": "Reagendar agendamento",
      "ok-title": "Reagendar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.confirmarReagendamentoAgenda
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nova data e horário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.agendaReagendamentoForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaReagendamentoForm, "data_inicio", $$v);
      },
      expression: "agendaReagendamentoForm.data_inicio"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Duração em minutos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.agendaReagendamentoForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaReagendamentoForm, "duracao_minutos", _vm._n($$v));
      },
      expression: "agendaReagendamentoForm.duracao_minutos"
    }
  })], 1), _c('div', {
    staticClass: "crm-agenda-horarios mb-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('div', [_c('strong', [_vm._v("Horários disponíveis")]), _c('small', {
    staticClass: "crm-agenda-context"
  }, [_vm._v(" " + _vm._s(_vm.agendaReagendamentoHorariosContextoLabel) + " ")])]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingAgendaReagendamentoHorarios
    },
    on: {
      "click": _vm.buscarHorariosReagendamentoAgenda
    }
  }, [_vm._v(" Buscar horários ")])]), _vm.agendaReagendamentoHorariosErro ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_vm._v(" " + _vm._s(_vm.agendaReagendamentoHorariosErro) + " ")]) : _vm.loadingAgendaReagendamentoHorarios ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Carregando horários... ")]) : _vm.agendaReagendamentoSlots.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Busque os horários antes de remarcar. ")]) : _c('div', {
    staticClass: "crm-agenda-slots"
  }, _vm._l(_vm.agendaReagendamentoSlots, function (slot) {
    return _c('button', {
      key: slot.inicio,
      staticClass: "crm-agenda-slot",
      class: {
        selected: _vm.agendaReagendamentoSlotSelecionado(slot),
        unavailable: !slot.disponivel
      },
      attrs: {
        "type": "button",
        "aria-pressed": _vm.agendaReagendamentoSlotSelecionado(slot),
        "disabled": !slot.disponivel
      },
      on: {
        "click": function click($event) {
          return _vm.selecionarHorarioReagendamentoAgenda(slot);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatTime(slot.inicio)))]), _c('small', [_vm._v(" " + _vm._s(slot.disponivel ? "Livre" : slot.motivo || "Ocupado") + " ")])]);
  }), 0)]), _c('b-form-group', {
    attrs: {
      "label": "Motivo do reagendamento"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "maxlength": "500",
      "rows": "3"
    },
    model: {
      value: _vm.agendaReagendamentoForm.motivo_reagendamento,
      callback: function callback($$v) {
        _vm.$set(_vm.agendaReagendamentoForm, "motivo_reagendamento", $$v);
      },
      expression: "agendaReagendamentoForm.motivo_reagendamento"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-link-solicitacao-modal",
      "title": "Gerar link de agenda",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_vm.linkSolicitacaoOrigem ? _c('div', {
    staticClass: "crm-link-modal"
  }, [_c('div', {
    staticClass: "crm-link-summary"
  }, [_c('span', [_vm._v("Solicitação técnica")]), _c('strong', [_vm._v(_vm._s(_vm.oportunidade ? _vm.oportunidade.titulo : ""))]), _c('small', [_vm._v(" " + _vm._s(_vm.solicitacaoTecnicaStatusLabel(_vm.linkSolicitacaoOrigem.status)) + " · " + _vm._s(_vm.linkSolicitacaoOrigem.tecnico || _vm.linkSolicitacaoOrigem.usuario_tecnico || "Responsável padrão") + " ")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkSolicitacaoForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.linkSolicitacaoForm, "data_inicio", $$v);
      },
      expression: "linkSolicitacaoForm.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkSolicitacaoForm.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.linkSolicitacaoForm, "data_fim", $$v);
      },
      expression: "linkSolicitacaoForm.data_fim"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração em minutos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.linkSolicitacaoForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.linkSolicitacaoForm, "duracao_minutos", $$v);
      },
      expression: "linkSolicitacaoForm.duracao_minutos"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observação para a tarefa"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "maxlength": "500",
      "placeholder": "Ex.: Cliente escolhe o melhor horário pelo link.",
      "rows": "2",
      "max-rows": "4"
    },
    model: {
      value: _vm.linkSolicitacaoForm.observacoes,
      callback: function callback($$v) {
        _vm.$set(_vm.linkSolicitacaoForm, "observacoes", $$v);
      },
      expression: "linkSolicitacaoForm.observacoes"
    }
  })], 1)], 1)], 1), _vm.linkSolicitacaoGerado ? _c('div', {
    staticClass: "crm-link-result"
  }, [_c('span', [_vm._v("Link gerado")]), _c('div', [_c('input', {
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.linkSolicitacaoGerado
    }
  }), _c('button', {
    staticClass: "crm-action-button",
    attrs: {
      "type": "button",
      "title": "Copiar link"
    },
    on: {
      "click": _vm.copiarLinkSolicitacaoModal
    }
  }, [_c('i', {
    staticClass: "la la-copy"
  }), _c('span', [_vm._v("Copiar")])])])]) : _vm._e(), _c('div', {
    staticClass: "crm-link-modal-actions"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-detalhe-link-solicitacao-modal');
      }
    }
  }, [_vm._v(" Fechar ")]), _c('button', {
    staticClass: "crm-action-button mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.linkSolicitacaoGerado || !_vm.contatoTelefone
    },
    on: {
      "click": _vm.enviarLinkSolicitacaoModalWhatsapp
    }
  }, [_c('i', {
    staticClass: "la la-whatsapp"
  }), _c('span', [_vm._v("WhatsApp")])]), _c('button', {
    staticClass: "crm-action-button mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.linkSolicitacaoGerado || !_vm.contatoEmail
    },
    on: {
      "click": _vm.enviarLinkSolicitacaoModalEmail
    }
  }, [_c('i', {
    staticClass: "la la-envelope"
  }), _c('span', [_vm._v("E-mail")])]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button",
      "disabled": _vm.linkSolicitacaoLoading
    },
    on: {
      "click": _vm.confirmarGerarLinkSolicitacaoTecnica
    }
  }, [_vm._v(" " + _vm._s(_vm.linkSolicitacaoLoading ? "Gerando..." : "Gerar link") + " ")])])], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-dados-modal",
      "title": "Editar dados comerciais",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "140"
    },
    model: {
      value: _vm.dadosForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "titulo", $$v);
      },
      expression: "dadosForm.titulo"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptions
    },
    on: {
      "change": _vm.onDadosFunilChange
    },
    model: {
      value: _vm.dadosForm.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "id_crm_funil", $$v);
      },
      expression: "dadosForm.id_crm_funil"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Etapa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.etapaOptions(_vm.dadosForm.id_crm_funil)
    },
    model: {
      value: _vm.dadosForm.id_crm_etapa,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "id_crm_etapa", $$v);
      },
      expression: "dadosForm.id_crm_etapa"
    }
  })], 1)], 1)], 1), _c('b-row', [!_vm.ocultarValoresFinanceirosDetalhe ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor estimado"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.dadosForm.valor_estimado,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "valor_estimado", $$v);
      },
      expression: "dadosForm.valor_estimado"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptions
    },
    model: {
      value: _vm.dadosForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "id_usuario", $$v);
      },
      expression: "dadosForm.id_usuario"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Previsão de fechamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.dadosForm.previsao_fechamento,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "previsao_fechamento", $$v);
      },
      expression: "dadosForm.previsao_fechamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Próxima ação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.dadosForm.proxima_atividade_em,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "proxima_atividade_em", $$v);
      },
      expression: "dadosForm.proxima_atividade_em"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fonte"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fonteOptions
    },
    model: {
      value: _vm.dadosForm.id_crm_fonte,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "id_crm_fonte", $$v);
      },
      expression: "dadosForm.id_crm_fonte"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Campanha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120",
      "placeholder": "Ex.: Black Friday, indicação, WhatsApp"
    },
    model: {
      value: _vm.dadosForm.campanha,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "campanha", $$v);
      },
      expression: "dadosForm.campanha"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Temperatura/qualificação"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.temperaturaOptions
    },
    model: {
      value: _vm.dadosForm.temperatura,
      callback: function callback($$v) {
        _vm.$set(_vm.dadosForm, "temperatura", $$v);
      },
      expression: "dadosForm.temperatura"
    }
  })], 1), _vm.camposComerciaisDetalhe.length ? _c('div', {
    staticClass: "crm-extra-fields"
  }, [_c('h4', [_vm._v("Campos comerciais")]), _c('b-row', _vm._l(_vm.camposComerciaisDetalhe, function (campo) {
    return _c('b-col', {
      key: campo.id_crm_campo_comercial,
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": campo.nome
      }
    }, [campo.chave === 'beneficios' || campo.chave === 'beneficios_livres' ? [_c('b-form-textarea', {
      attrs: {
        "rows": "3",
        "max-rows": "5",
        "placeholder": "Digite descontos, parcelamentos, bônus ou observações combinadas."
      },
      model: {
        value: _vm.dadosForm.campos_comerciais[campo.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.dadosForm.campos_comerciais, campo.id_crm_campo_comercial, $$v);
        },
        expression: "\n                  dadosForm.campos_comerciais[campo.id_crm_campo_comercial]\n                "
      }
    })] : campo.chave === 'beneficios_estruturados' ? [_c('div', {
      staticClass: "crm-benefit-suggestions"
    }, _vm._l(_vm.beneficioOptions, function (beneficio) {
      return _c('button', {
        key: beneficio.value,
        class: ['crm-benefit-chip', {
          active: _vm.beneficioCampoSelecionado(campo.id_crm_campo_comercial, beneficio.value)
        }],
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.toggleBeneficioCampo(campo.id_crm_campo_comercial, beneficio.value);
          }
        }
      }, [_vm._v(" " + _vm._s(beneficio.text) + " ")]);
    }), 0)] : campo.tipo === 'lista' ? _c('b-form-select', {
      attrs: {
        "options": _vm.campoComercialOptions(campo)
      },
      model: {
        value: _vm.dadosForm.campos_comerciais[campo.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.dadosForm.campos_comerciais, campo.id_crm_campo_comercial, $$v);
        },
        expression: "\n                dadosForm.campos_comerciais[campo.id_crm_campo_comercial]\n              "
      }
    }) : campo.tipo === 'booleano' ? _c('b-form-checkbox', {
      attrs: {
        "value": "1",
        "unchecked-value": "0"
      },
      model: {
        value: _vm.dadosForm.campos_comerciais[campo.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.dadosForm.campos_comerciais, campo.id_crm_campo_comercial, $$v);
        },
        expression: "\n                dadosForm.campos_comerciais[campo.id_crm_campo_comercial]\n              "
      }
    }, [_vm._v(" Sim ")]) : _c('b-form-input', {
      attrs: {
        "type": _vm.campoInputType(campo)
      },
      model: {
        value: _vm.dadosForm.campos_comerciais[campo.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.dadosForm.campos_comerciais, campo.id_crm_campo_comercial, $$v);
        },
        expression: "\n                dadosForm.campos_comerciais[campo.id_crm_campo_comercial]\n              "
      }
    })], 2)], 1);
  }), 1)], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-detalhe-dados-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarDados
    }
  }, [_vm._v(" Salvar alterações ")])])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-temperatura-modal",
      "title": "Temperatura da oportunidade"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.salvarTemperaturaDetalhe.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Oportunidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.oportunidade ? _vm.oportunidade.titulo : '',
      "disabled": ""
    }
  })], 1), _c('div', {
    staticClass: "crm-temperature-grid"
  }, _vm._l(_vm.temperaturaOptions, function (option) {
    return _c('button', {
      key: String(option.value),
      staticClass: "crm-temperature-option",
      class: {
        active: _vm.temperaturaForm.temperatura === option.value
      },
      style: {
        '--temperature-color': _vm.temperaturaColor(option.value)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.temperaturaForm.temperatura = option.value;
        }
      }
    }, [_c('i', {
      class: _vm.temperaturaIcon(option.value)
    }), _c('span', [_vm._v(_vm._s(option.text))])]);
  }), 0)], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-mover-etapa-modal",
      "title": "Mover oportunidade"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.confirmarMoverEtapaDetalhe.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Etapa de destino"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.etapaOptions(_vm.oportunidade ? _vm.oportunidade.id_crm_funil : null)
    },
    on: {
      "change": _vm.prepararCamposMovimento
    },
    model: {
      value: _vm.idEtapaDestino,
      callback: function callback($$v) {
        _vm.idEtapaDestino = $$v;
      },
      expression: "idEtapaDestino"
    }
  })], 1), _vm.movimentoExigeTecnico ? _c('b-form-group', {
    attrs: {
      "label": "Desenvolvedor da apresentação"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.desenvolvedorResponsavelOptions
    },
    model: {
      value: _vm.idUsuarioTecnicoDestino,
      callback: function callback($$v) {
        _vm.idUsuarioTecnicoDestino = $$v;
      },
      expression: "idUsuarioTecnicoDestino"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Este desenvolvedor assume a apresentação técnica e a implementação White Label. ")])], 1) : _vm._e(), _vm.movimentoExigeAtribuicao ? _c('b-form-group', {
    attrs: {
      "label": "Vendedor responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.vendedorResponsavelOptions
    },
    model: {
      value: _vm.idUsuarioDestino,
      callback: function callback($$v) {
        _vm.idUsuarioDestino = $$v;
      },
      expression: "idUsuarioDestino"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Este vendedor ficará vinculado ao card durante todo o fluxo comercial. ")]), _vm.usuarioDestinoSemAcesso ? _c('b-form-checkbox', {
    staticClass: "mt-3",
    model: {
      value: _vm.concederAcessoFunilDestino,
      callback: function callback($$v) {
        _vm.concederAcessoFunilDestino = $$v;
      },
      expression: "concederAcessoFunilDestino"
    }
  }, [_vm._v(" Conceder acesso deste usuário ao funil atual ")]) : _vm._e()], 1) : _vm._e(), _vm.camposObrigatoriosMovimento.length ? _c('div', {
    staticClass: "crm-move-requirements"
  }, [_c('b-alert', {
    staticClass: "mb-4",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Esta etapa exige informações antes de receber a oportunidade. ")]), _vm.movimentoExigeValorNegociacao ? _c('b-form-group', {
    attrs: {
      "label": "Valor negociado"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        value: true,
        text: 'Manter o valor já informado'
      }, {
        value: false,
        text: 'Informar novo valor'
      }],
      "stacked": ""
    },
    on: {
      "change": _vm.prepararCamposMovimento
    },
    model: {
      value: _vm.movimentoManterValor,
      callback: function callback($$v) {
        _vm.movimentoManterValor = $$v;
      },
      expression: "movimentoManterValor"
    }
  })], 1) : _vm._e(), _vm._l(_vm.camposObrigatoriosMovimento, function (regra) {
    return _c('b-form-group', {
      key: regra.id_crm_etapa_campo_obrigatorio,
      attrs: {
        "label": _vm.labelCampoObrigatorio(regra)
      }
    }, [_vm.campoObrigatorioTipo(regra) === 'lista' ? _c('b-form-select', {
      attrs: {
        "options": _vm.campoObrigatorioOptions(regra)
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _vm.campoObrigatorioTipo(regra) === 'texto_longo' ? _c('b-form-textarea', {
      attrs: {
        "rows": "3"
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _vm.campoObrigatorioTipo(regra) === 'numero' && _vm.isCampoObrigatorioMonetario(regra) ? _c('money', _vm._b({
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.movimentoManterValor && _vm.campoObrigatorioChave(regra) === 'valor_negociacao'
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }, 'money', _vm.priceOptions, false)) : _vm.campoObrigatorioTipo(regra) === 'numero' ? _c('b-form-input', {
      attrs: {
        "type": "number",
        "step": "0.01",
        "disabled": _vm.movimentoManterValor && _vm.campoObrigatorioChave(regra) === 'valor_negociacao'
      },
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }) : _c('b-form-input', {
      model: {
        value: _vm.movimentoCamposForm[regra.id_crm_campo_comercial],
        callback: function callback($$v) {
          _vm.$set(_vm.movimentoCamposForm, regra.id_crm_campo_comercial, $$v);
        },
        expression: "movimentoCamposForm[regra.id_crm_campo_comercial]"
      }
    }), regra.mensagem ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(regra.mensagem) + " ")]) : _vm._e()], 1);
  })], 2) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-contato-modal",
      "title": "Contato da oportunidade",
      "hide-footer": ""
    }
  }, [_c('BuscaClienteContato', {
    attrs: {
      "label": "Contato principal",
      "incluir-pessoas": false
    },
    on: {
      "criar-contato": _vm.criarContatoRapidoOportunidade
    },
    model: {
      value: _vm.contatoSelecionado,
      callback: function callback($$v) {
        _vm.contatoSelecionado = $$v;
      },
      expression: "contatoSelecionado"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-detalhe-contato-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarContatoOportunidade
    }
  }, [_vm._v(" Salvar contato ")])])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-empresa-modal",
      "title": "Associar empresa/pessoa",
      "hide-footer": ""
    }
  }, [_c('BuscaClienteContato', {
    attrs: {
      "label": "Pessoa existente",
      "placeholder": "Busque pelo nome, fantasia ou documento",
      "incluir-contatos": false,
      "permite-criar-contato": false
    },
    model: {
      value: _vm.empresaSelecionada,
      callback: function callback($$v) {
        _vm.empresaSelecionada = $$v;
      },
      expression: "empresaSelecionada"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-detalhe-empresa-modal');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarEmpresaOportunidade
    }
  }, [_vm._v(" Associar ")])])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-perda-modal",
      "title": "Marcar como perdida"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.marcarPerdida.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Motivo da perda"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.motivoPerdaOptions
    },
    model: {
      value: _vm.perdaForm.id_crm_motivo_perda,
      callback: function callback($$v) {
        _vm.$set(_vm.perdaForm, "id_crm_motivo_perda", $$v);
      },
      expression: "perdaForm.id_crm_motivo_perda"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Observação"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.perdaForm.motivo_perda_observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.perdaForm, "motivo_perda_observacao", $$v);
      },
      expression: "perdaForm.motivo_perda_observacao"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-ganho-modal",
      "title": "Fechar oportunidade",
      "cancel-title": "Cancelar",
      "ok-title": "Confirmar",
      "size": "xl"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.marcarGanha.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "crm-close-summary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.ganhoForm.titulo))]), _c('span', [_vm._v(_vm._s(_vm.ganhoForm.cliente))])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome correto"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: _vm.ganhoForm.nome_correto,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "nome_correto", $$v);
      },
      expression: "ganhoForm.nome_correto"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CNPJ"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "maxlength": "18"
    },
    model: {
      value: _vm.ganhoForm.cnpj,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "cnpj", $$v);
      },
      expression: "ganhoForm.cnpj"
    }
  }), _c('b-input-group-append', [_c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingConsultaCnpjFechamento
    },
    on: {
      "click": _vm.consultarCnpjFechamento
    }
  }, [_c('i', {
    staticClass: "la la-search"
  }), _vm._v(" Consultar ")])])], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "maxlength": "120"
    },
    model: {
      value: _vm.ganhoForm.email_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "email_cliente", $$v);
      },
      expression: "ganhoForm.email_cliente"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Telefone"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20"
    },
    model: {
      value: _vm.ganhoForm.telefone_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "telefone_cliente", $$v);
      },
      expression: "ganhoForm.telefone_cliente"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "crm-close-address"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "maxlength": "9"
    },
    model: {
      value: _vm.ganhoForm.cep,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "cep", $$v);
      },
      expression: "ganhoForm.cep"
    }
  }), _c('b-input-group-append', [_c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingConsultaCepFechamento
    },
    on: {
      "click": _vm.consultarCepFechamento
    }
  }, [_c('i', {
    staticClass: "la la-search"
  }), _vm._v(" Consultar ")])])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.cidadeFechamentoLabel,
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Logradouro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganhoForm.logradouro,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "logradouro", $$v);
      },
      expression: "ganhoForm.logradouro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "30"
    },
    model: {
      value: _vm.ganhoForm.numero,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "numero", $$v);
      },
      expression: "ganhoForm.numero"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganhoForm.bairro,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "bairro", $$v);
      },
      expression: "ganhoForm.bairro"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Complemento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: _vm.ganhoForm.complemento,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "complemento", $$v);
      },
      expression: "ganhoForm.complemento"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Endereço completo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "255"
    },
    model: {
      value: _vm.ganhoForm.endereco_cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "endereco_cliente", $$v);
      },
      expression: "ganhoForm.endereco_cliente"
    }
  })], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Valor final"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.ganhoForm.valor_final,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "valor_final", $$v);
      },
      expression: "ganhoForm.valor_final"
    }
  }, 'money', _vm.priceOptions, false))], 1), _c('b-form-group', {
    attrs: {
      "label": "Benefícios digitáveis"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3",
      "max-rows": "5",
      "placeholder": "Digite descontos, parcelamentos, bônus ou observações combinadas."
    },
    model: {
      value: _vm.ganhoForm.beneficios_livres,
      callback: function callback($$v) {
        _vm.$set(_vm.ganhoForm, "beneficios_livres", $$v);
      },
      expression: "ganhoForm.beneficios_livres"
    }
  })], 1), !_vm.ganhoForm.cliente_final ? _c('b-form-group', {
    attrs: {
      "label": "Benefícios de regra"
    }
  }, [_c('div', {
    staticClass: "crm-benefit-suggestions"
  }, _vm._l(_vm.beneficioOptions, function (beneficio) {
    return _c('button', {
      key: beneficio.value,
      class: ['crm-benefit-chip', {
        active: _vm.beneficioEstruturadoSelecionado(beneficio.value)
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleBeneficioGanho(beneficio.value);
        }
      }
    }, [_vm._v(" " + _vm._s(beneficio.text) + " ")]);
  }), 0)]) : _vm._e(), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Ao confirmar, o CRM salva os dados do cliente, registra os benefícios na oportunidade e cria a entrada no funil Contratos. ")])], 1), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-dados-negociacao-modal",
      "title": "Dados da negociação",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "crm-negotiation-data"
  }, [_c('div', [_c('span', [_vm._v("Cliente")]), _c('strong', [_vm._v(_vm._s(_vm.contatoPrincipal))])]), _c('div', [_c('span', [_vm._v("Negociação original")]), _c('strong', [_vm._v(" " + _vm._s(_vm.oportunidade.oportunidade_origem || _vm.oportunidade.titulo) + " ")])]), _c('div', [_c('span', [_vm._v("Valor negociado")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.valorPrincipalDetalhe)))])]), _c('div', [_c('span', [_vm._v("Telefone")]), _c('strong', [_vm._v(_vm._s(_vm.contatoTelefone || "Não informado"))])]), _c('div', [_c('span', [_vm._v("E-mail")]), _c('strong', [_vm._v(_vm._s(_vm.contatoEmail || "Não informado"))])]), _vm._l(_vm.camposComerciaisDetalhe, function (campo) {
    return _c('div', {
      key: campo.chave
    }, [_c('span', [_vm._v(_vm._s(campo.nome))]), _c('strong', [_vm._v(_vm._s(_vm.campoValorLabel(campo)))])]);
  })], 2), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('crm-detalhe-dados-negociacao-modal');
      }
    }
  }, [_vm._v(" Fechar ")])])]), _c('b-modal', {
    attrs: {
      "id": "crm-detalhe-responsaveis-contrato-modal",
      "title": "Responsáveis pós-contrato",
      "ok-disabled": _vm.contratoResponsaveisLoading,
      "cancel-disabled": _vm.contratoResponsaveisLoading,
      "ok-title": "Concluir contrato",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.confirmarConclusaoContrato.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "crm-contract-destination-summary"
  }, [_vm.contratoExigeImplementacaoWhiteLabel ? _c('div', [_c('span', [_vm._v("Implementação White Label")]), _c('strong', [_vm._v(_vm._s(_vm.contratoResponsavelWhiteLabelLabel))])]) : _vm._e(), _vm.contratoExigeTreinamentoClienteFinal ? _c('div', [_c('span', [_vm._v("Treinamento Cliente Final")]), _c('strong', [_vm._v(_vm._s(_vm.contratoTreinamentoClienteFinalSelecionadoLabel))])]) : _vm._e(), _vm.contratoExigeTreinamento ? _c('div', [_c('span', [_vm._v("Treinamento")]), _c('strong', [_vm._v(_vm._s(_vm.contratoTreinamentoSelecionadoLabel))])]) : _vm._e(), _vm.contratoExigeWebsite ? _c('div', [_c('span', [_vm._v("Website")]), _c('strong', [_vm._v(_vm._s(_vm.contratoWebsiteSelecionadoLabel))])]) : _vm._e()]), _c('div', {
    staticClass: "crm-contract-responsibles-form"
  }, [_vm.contratoExigeImplementacaoWhiteLabel ? _c('label', [_c('span', [_vm._v("Responsável pela implementação White Label")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.contratoResponsaveisForm.id_usuario_white_label,
      expression: "contratoResponsaveisForm.id_usuario_white_label",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.contratoResponsaveisForm, "id_usuario_white_label", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o responsável")]), _vm._l(_vm.desenvolvedorResponsavelOptions, function (option) {
    return _c('option', {
      key: "white-label-".concat(option.value),
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _vm.desenvolvedorResponsavelOptions.length === 0 ? _c('small', [_vm._v(" Nenhum desenvolvedor disponível nas atribuições. ")]) : _vm._e()]) : _vm._e(), _vm.contratoExigeTreinamentoClienteFinal ? _c('label', [_c('span', [_vm._v("Responsável pelo Treinamento Cliente Final")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.contratoResponsaveisForm.id_usuario_treinamento_cliente_final,
      expression: "\n            contratoResponsaveisForm.id_usuario_treinamento_cliente_final\n          ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.contratoResponsaveisForm, "id_usuario_treinamento_cliente_final", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o responsável")]), _vm._l(_vm.treinamentoClienteFinalResponsavelOptions, function (option) {
    return _c('option', {
      key: "treinamento-cliente-final-".concat(option.value),
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _vm.treinamentoClienteFinalResponsavelOptions.length === 0 ? _c('small', [_vm._v(" Nenhum usuário de Treinamento Cliente Final disponível nas atribuições. ")]) : _vm._e()]) : _vm._e(), _vm.contratoExigeTreinamento ? _c('label', [_c('span', [_vm._v("Responsável pelo treinamento")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.contratoResponsaveisForm.id_usuario_treinamento,
      expression: "contratoResponsaveisForm.id_usuario_treinamento",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.contratoResponsaveisForm, "id_usuario_treinamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o responsável")]), _vm._l(_vm.treinamentoResponsavelOptions, function (option) {
    return _c('option', {
      key: "treinamento-".concat(option.value),
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _vm.treinamentoResponsavelOptions.length === 0 ? _c('small', [_vm._v(" Nenhum usuário de treinamento disponível nas atribuições. ")]) : _vm._e()]) : _vm._e(), _vm.contratoExigeWebsite ? _c('label', [_c('span', [_vm._v("Responsável pelo website")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.contratoResponsaveisForm.id_usuario_website,
      expression: "contratoResponsaveisForm.id_usuario_website",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.contratoResponsaveisForm, "id_usuario_website", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione o responsável")]), _vm._l(_vm.websiteResponsavelOptions, function (option) {
    return _c('option', {
      key: "website-".concat(option.value),
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _vm.websiteResponsavelOptions.length === 0 ? _c('small', [_vm._v(" Nenhum usuário de website disponível nas atribuições. ")]) : _vm._e()]) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };